import { render, staticRenderFns } from "./BuyerAccounts.vue?vue&type=template&id=d05f6950&scoped=true"
import script from "./BuyerAccounts.vue?vue&type=script&lang=js"
export * from "./BuyerAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05f6950",
  null
  
)

export default component.exports